import React from 'react';
import {
    Alert,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from '@mui/material';
import { COLORS } from '../../../utils/Application_Constants';

const styles = {
    container: {
        borderRadius: 2,
        p: 1.5,
        width: 536,
        maxWidth: '90vw',
        overflow: 'visible',
    },
    cancelButton: {
        textTransform: 'none',
        borderRadius: '4px',
        minWidth: 120,
        borderColor: COLORS.LT_JOURNEY,
        color: COLORS.LT_JOURNEY,
        backgroundColor: COLORS.WHITE,
        '&:hover': {
            borderColor: COLORS.LT_JOURNEY125,
            color: COLORS.LT_JOURNEY125,
            backgroundColor: COLORS.WHITE,
        },
        '& .MuiTouchRipple-root': { color: COLORS.LT_JOURNEY },
        py: 1,
        px: 6,
    },
    confirmButton: {
        textTransform: 'none',
        borderRadius: '4px',
        minWidth: 120,
        backgroundColor: COLORS.LT_JOURNEY,
        color: COLORS.WHITE,
        boxShadow: 'none',
        '&:hover': {
            backgroundColor: COLORS.LT_JOURNEY125,
            boxShadow: 'none',
        },
        py: 1,
        px: 6,
    },
    actionsContainer: {
        gap: 1.5,
        justifyContent: 'flex-start',
        pl: 3,
        pb: 3,
    },
};

const PayrollDayWarningDialog = ({ open, message, onCancel, onConfirm }) => (
    <Dialog
        open={open}
        onClose={onCancel}
        aria-labelledby="payroll-day-warning-title"
        maxWidth={false}
        scroll="body"
        slotProps={{
            paper: {
                sx: styles.container,
            },
        }}
    >
        <DialogTitle id="payroll-day-warning-title" sx={{ pb: 0 }}>
            <Typography variant="h5" sx={{ mb: 3, mt: 3 }}>
                Payroll Day Warning
            </Typography>
        </DialogTitle>
        <DialogContent sx={{ overflow: 'visible' }}>
            <Alert severity="warning" sx={{ mb: 1 }}>
                {message}
            </Alert>
        </DialogContent>
        <DialogActions sx={styles.actionsContainer}>
            <Button onClick={onCancel} variant="outlined" sx={styles.cancelButton}>
                Cancel
            </Button>
            <Button onClick={onConfirm} variant="contained" sx={styles.confirmButton}>
                Confirm
            </Button>
        </DialogActions>
    </Dialog>
);

export default PayrollDayWarningDialog;
